import React from 'react';
import { cloneDeep } from 'lodash-es';

function getUserAuthorizationCode(){
    const authCode = JSON.parse(localStorage.getItem('memzo-auth-token'));
    return authCode;

}
export const AUTHORIZATION_CODE= getUserAuthorizationCode();
export const API_ENDPOINT='https://snapwrap.io/v1/b2b/index.php';


export const convertProxyObjectToObj = (proxyObj) =>  {
    return cloneDeep(proxyObj);
  }